// ══════════════════════════════════════════════════════════════════════════════════════════════
//  B-901 · EL TEMA ES DE CADA PERSONA, NO DEL DISPOSITIVO (27-sep-2026)
// ══════════════════════════════════════════════════════════════════════════════════════════════
//
//  El dueño: «Por defecto, la app debe salir en modo claro, y solo sale en modo oscuro cuando ese usuario lo ha cambiado a
//  modo oscuro ya que se debe guardar su preferencia».
//
//  Va dentro de la sesión (App.jsx) y no pinta nada. Cuando entra alguien (o cambia quien tiene la sesión), aplica SU tema:
//  al instante la copia de este dispositivo, y en cuanto contesta el servidor, la de su perfil (`tema_oscuro` en
//  GET /auth/preferencias), que manda. Al salir, claro. Y le registra al tema cómo guardar en su perfil lo que elija con el
//  botón (PATCH /auth/preferencias, que funde con lo demás que tenga guardado). Ver context/ThemeContext.jsx.
import { useEffect } from 'react'
import { useAuth } from '../context/AuthContext'
import { useTheme } from '../context/ThemeContext'
import api from '../services/api'

export default function TemaDeLaSesion() {
  const { user } = useAuth()
  const { aplicarUsuario, registrarGuardado } = useTheme()
  const id = user?.id || null
  useEffect(() => {
    let vivo = true
    const guardarEnSuPerfil = (oscuro) => api.patch('/auth/preferencias', cuerpoDelTema(oscuro)).catch(() => {})
    registrarGuardado(id ? guardarEnSuPerfil : null)
    const heredado = aplicarUsuario(id, undefined)
    if (id) {
      if (heredado === true) guardarEnSuPerfil(true)
      api.get('/auth/preferencias').then((r) => {
        if (!vivo) return
        const v = r && r.data ? r.data.tema_oscuro : undefined
        if (typeof v === 'boolean') aplicarUsuario(id, v)
      }).catch(() => { /* sin su perfil, vale lo de este dispositivo */ })
    }
    return () => { vivo = false }
  }, [id, aplicarUsuario, registrarGuardado])
  return null
}

// Lo que se guarda en el perfil. Pura: la mide la guardia (va DETRÁS del componente: las guardias cogen el primero).
export const cuerpoDelTema = (oscuro) => ({ tema_oscuro: !!oscuro })
